export default "__VITE_ASSET__94a9917f__"